import styled from 'styled-components';

import {Link} from 'components/ui-kit/Link';

import {colors} from 'theme';

export const Container = styled.div`
    margin-top: 100px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
        margin-bottom: 40px;
    }
`;

export const CustomLink = styled(Link)`
    font-size: 20px;
`;

export const Back = styled.div`
    color: ${colors.brandPrimary};
    font-size: 20px;
    cursor: pointer;
`;
